import { render, staticRenderFns } from "./DialogNotice.vue?vue&type=template&id=63408d28&scoped=true&"
import script from "./DialogNotice.vue?vue&type=script&lang=js&"
export * from "./DialogNotice.vue?vue&type=script&lang=js&"
import style0 from "./DialogNotice.vue?vue&type=style&index=0&id=63408d28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63408d28",
  null
  
)

export default component.exports